import { render, staticRenderFns } from "./tipo.vue?vue&type=template&id=c7b59138&"
import script from "./tipo.vue?vue&type=script&lang=js&"
export * from "./tipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7b59138')) {
      api.createRecord('c7b59138', component.options)
    } else {
      api.reload('c7b59138', component.options)
    }
    module.hot.accept("./tipo.vue?vue&type=template&id=c7b59138&", function () {
      api.rerender('c7b59138', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/tipo.vue"
export default component.exports